import React, { useMemo, useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Formik } from 'formik';
import { isEqual } from 'lodash';
import axios, { baseUrl } from '../../../../../redux/my-axios';

const PARAM_URL = '/params';
const prepareFilter = (queryParams, values) => {
  const { from, to, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  filter.from = from;
  filter.to = to;
  if (searchText) {
    filter.searchText = searchText;
  }
  newQueryParams.filter = filter;
  return newQueryParams;
};

const Filter = (props) => {
  const { intl, queryParams, setQueryParams } = props;

  const [loaded, setLoaded] = useState(false);

  // queryParams, setQueryParams,
  const applyFilter = (values) => {
    //console.log("applyFilter", values);
    const newQueryParams = prepareFilter(queryParams, values);
    if (!isEqual(newQueryParams, queryParams)) {
      newQueryParams.pageNumber = 1;
      setQueryParams(newQueryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          from: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30)
            .toISOString()
            .slice(0, 10),
          to: new Date(new Date().getTime() + 1000 * 60 * 60 * 24)
            .toISOString()
            .slice(0, 10),
          searchText: '',
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className='form form-label-right'>
            <div className='form-group row'>
              <div className='col-lg-2'>
                <div
                  style={{
                    display: 'inline-flex',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <input
                    //placeholder="yyyy-mm-dd"
                    type='date'
                    //format="yyyy-mm-dd"
                    className='form-control'
                    placeholder='-с'
                    onBlur={handleBlur}
                    value={values.from}
                    onChange={(e) => {
                      setFieldValue('from', e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className='form-text text-muted'>
                    <b>
                      <FormattedMessage id='SALES.LABEL.FROM' />
                    </b>
                  </small>
                </div>
              </div>
              <div className='col-lg-2'>
                <div
                  style={{
                    display: 'inline-flex',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <input
                    type='date'
                    className='form-control'
                    name='to'
                    onBlur={handleBlur}
                    value={values.to}
                    onChange={(e) => {
                      setFieldValue('to', e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className='form-text text-muted'>
                    <b>
                      <FormattedMessage id='SALES.LABEL.TO' />
                    </b>
                  </small>
                </div>
              </div>
              {/*  <div className='col-lg-2'>
                <select
                  className='form-control'
                  name='saleType'
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue('saleType', e.target.value);
                    handleSubmit();
                  }}
                  value={values.saleType}
                >
                  {saleTypeList.map((option) => (
                    <option
                      key={`saleTypeList${option.key}`}
                      value={option.key}
                    >
                      {option.value}
                    </option>
                  ))}
                </select>
              </div> */}

              <div className='col-lg-4'>
                <input
                  type='text'
                  className='form-control'
                  name='searchText'
                  placeholder='текстээс хайх'
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue('searchText', e.target.value);
                    handleSubmit();
                  }}
                />
              </div>

              <div className='col-lg-2'>
                <button
                  id='kt_order_search_submit'
                  type='submit'
                  /* disabled={formik.isSubmitting} */
                  className={`btn btn-primary font-weight-bold `}
                  onClick={handleSubmit}
                >
                  <FormattedMessage id='SALES.LABEL.SEARCH' />
                  {/*   <span><FormattedMessage id="AUTH.LOGIN.BUTTON" /></span> */}
                  {/* {values.loading && <span className="ml-3 spinner spinner-white"></span>} */}
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

export default injectIntl(Filter);
